/* eslint-disable @typescript-eslint/no-explicit-any */
import { captureException } from '@sentry/core';
import type { AxiosError } from 'axios';
import { toast } from 'react-toastify';

const NETWORK_ERROR = 'Network Error';
const DEFAULT_ERROR_MESSAGE = 'Houve um erro na sua requisição.';

export const handleResponseError = <T>(
  defaultResponse: T,
  errorMessage: string = DEFAULT_ERROR_MESSAGE,
) => {
  return (error: Error): T => {
    toast.error(errorMessage, { toastId: errorMessage });

    if (error.message !== NETWORK_ERROR) {
      captureException(error, {
        tags: {
          validateResponse: true,
        },
        level: 'error',
      });
    }

    return defaultResponse;
  };
};

export const handleResponseThrowError = (
  errorDefaultMessage?: string,
  showToast: boolean = true,
) => {
  return (error: AxiosError<any>) => {
    const errorMessage: string =
      error?.response?.data?.message ||
      errorDefaultMessage ||
      DEFAULT_ERROR_MESSAGE;

    if (error.message !== NETWORK_ERROR) {
      captureException(error, {
        tags: {
          validateResponse: true,
        },
        level: 'error',
      });
    }
    if (showToast) {
      toast.error(errorMessage, {
        toastId: errorMessage,
      });
    }

    throw error;
  };
};

export const handleResponseSuccess = <T>(
  response: T,
  successMessage: string,
) => {
  return () => {
    if (successMessage) {
      toast.success(successMessage);
    }
    return response;
  };
};
